module.exports = __webpack_public_path__ + "static/grafika15@2x-e1c415497dc3419f53dc9fec76c7b04b.png";